// src/modules/auth/pages/LoginPage.js

import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginForm from '../components/LoginForm';
import authService from '../services/authService';

const LoginPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        // Verificar si ya hay una sesión iniciada
        if (authService.isAuthenticated()) {
            navigate('/now', { replace: true });
        }
    }, [navigate]);

    return <LoginForm />;
};

export default LoginPage;
